"use strict";
import { getAtomicSupportedChainIds } from "state/walletCapabilities/lib/handleGetCapabilities";
import { deepEqual } from "wagmi";
export function createOnSetCapabilitiesByChainEffect(ctx) {
  const { getOriginalState, onAtomicSupportedChainIdsDetected, onWalletCapabilitiesDetected, logger } = ctx;
  return (action) => {
    const state = getOriginalState();
    const existingCapabilities = state.walletCapabilities.byChain;
    if (deepEqual(existingCapabilities, action.payload)) {
      logger?.info("reducer.ts", "createOnSetCapabilitiesByChainEffect", "wallet capabilities are the same");
      return;
    }
    const atomicSupportedChainIds = getAtomicSupportedChainIds(action.payload);
    if (atomicSupportedChainIds.length > 0) {
      logger?.info("reducer.ts", "createOnSetCapabilitiesByChainEffect", "atomic supported chain ids detected", {
        atomicSupportedChainIds
      });
      onAtomicSupportedChainIdsDetected(atomicSupportedChainIds);
    }
    onWalletCapabilitiesDetected(action.payload);
    logger?.info("reducer.ts", "createOnSetCapabilitiesByChainEffect", "wallet capabilities detected", {
      payload: action.payload
    });
  };
}
